import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function InstallationPopup({ callInstallation }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('customize_bundle_for_dpu.installation');
    const lists: any[] = [t('list1'), t('list2'), t('list3'), t('list4')];

    return (
        <div className={`installation-popup ${css['installation-popup']}`}>
            <div className="installation-popup-content">
                <header className="installation-popup-header">
                    <svg
                        className="header-close"
                        onClick={() => callInstallation(false)}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </header>
                <body className="installation-popup-body">
                    <p className="installation-title">{t('title')}</p>
                    <p className="installation-desc">{t('desc')}</p>
                    <p className="installation-text">{t('text')}</p>
                    <ul className="lists">
                        {lists?.map((list: any, k: number) => (
                            <li className="list" key={k}>
                                <span className="list-step">{k + 1}</span>
                                <span className="list-text">{list}</span>
                            </li>
                        ))}
                    </ul>
                </body>
            </div>
            {/* <style jsx global>
                {`
                    .page-layout {
                        height: 100vh !important;
                        overflow: hidden !important;
                    }
                `}
            </style> */}
        </div>
    );
}
